import { Component, Inject } from "@angular/core";
import { CrewPermissionsService } from "../core/crew-permissions.service";
import { ListBase } from "../settings/shared/list.base";

@Component({
    selector: "crew-work-schedules",
    template: require('../settings/shared/list-view.html')
})
export class WorkSchedulesComponent extends ListBase<Nema.Crew.Model.WorkSchedule> {

    constructor(
        @Inject("workSchedules") workSchedules: Nema.Crew.Model.WorkSchedule[],
        crewPermissionsService: CrewPermissionsService) {

        super(workSchedules, crewPermissionsService);
    }

    public newEntityState: string = "app.activities.workschedules.new";

    public editEntityState: string = "app.activities.workschedules.detail";

    public entityName: string = "Work Schedule";

    public entityNames: string = "Work Schedules";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/work-schedules.component.ts